import React, { useEffect, useState } from "react";
import { Grid, useMediaQuery, useTheme, Hidden } from "@material-ui/core";
import MoreGreatFeatures from "./MoreGreatFeatures";
import Introduction from "./Introduction";
import SubFooter from "../SubFooter";
import SectionTwo from "./SectionTwo";
import SectionThree from "./SectionThree";
//import HomeJournerySimplified from "./HomeJournerySimplified";
import CompanyLogos from "../serviceProviders/CompanyLogos";
import FrequentlyAskedQuestions from "./FrequentlyAskedQuestions";
function BecomeRealEstateAgent() {
  const theme = useTheme();
  const smUp = useMediaQuery(theme.breakpoints.up("sm"));
  const smDown = useMediaQuery(theme.breakpoints.down("sm"));
  const mdUp = useMediaQuery(theme.breakpoints.up("md"));
  const mdDown = useMediaQuery(theme.breakpoints.down("md"));
  const lgUp = useMediaQuery(theme.breakpoints.up("lg"));
  const lgDown = useMediaQuery(theme.breakpoints.down("lg"));
  const xlUp = useMediaQuery(theme.breakpoints.up("xl"));
  const xsDown = useMediaQuery(theme.breakpoints.down("xs"));
  const commonPadding = lgUp ? "0px 6%" : "0px 2%";
  // const commonPadding = 0;
  const [selectedTab, setselectedTab] = useState(0);
  const title = "Comprehensive guide on how to become a real estate agent in Ontario.";
  const subTitle =
  "If you’re looking for available licensed realtors in Toronto, Ottawa, Mississauga and other cities check out our database on souqh.ca. ";
  const btnText = "Search Now!";
  const redirectUrl = "https://app.souqh.ca/marketplace?websiteSearchedServiceId=Real%20Estate%20Broker%20/%20Agent&websiteSearchedCityId=1";

  useEffect(() => {
    window.scrollTo(0, 0);
  });

  return (
    <div
      style={{
        overflow: "hidden",
        position: "relative",
        top: smUp ? (lgUp ? 55 : 60) : 78,
        marginBottom: 105,
      }}
    >
      <Introduction
        smUp={smUp}
        smDown={smDown}
        mdUp={mdUp}
        mdDown={mdDown}
        lgUp={lgUp}
        xlUp={xlUp}
        xsDown={xsDown}
        commonPadding={commonPadding}
      />
       
      <Hidden lgUp mdUp smUp xsUp>
       <MoreGreatFeatures
        smUp={smUp}
        mdUp={mdUp}
        lgUp={lgUp}
        xsDown={xsDown}
        commonPadding={commonPadding}
      ></MoreGreatFeatures>
      </Hidden>
      <SectionThree
        smUp={smUp}
        smDown={smDown}
        mdUp={mdUp}
        mdDown={mdDown}
        lgUp={lgUp}
        xlUp={xlUp}
        xsDown={xsDown}
        commonPadding={commonPadding}
      />
      <SectionTwo
        smUp={smUp}
        smDown={smDown}
        mdUp={mdUp}
        mdDown={mdDown}
        lgUp={lgUp}
        xlUp={xlUp}
        xsDown={xsDown}
        commonPadding={commonPadding}
      />
        <FrequentlyAskedQuestions
        smUp={smUp}
        smDown={smDown}
        mdUp={mdUp}
        mdDown={mdDown}
        lgUp={lgUp}
        xlUp={xlUp}
        xsDown={xsDown}
        commonPadding={commonPadding}
      />
      <SubFooter
        title={title}
        subTitle={subTitle}
        btnText={btnText}
        redirectUrl={redirectUrl}
      />
    </div>
  );
}

export default BecomeRealEstateAgent;
